import React from 'react';
import { Field, Text, SectionShell } from './FormControls';

const ReliefValveSection = ({ data, update }) => (
  <SectionShell title="Relief Valve Details">
    <Field label="Manufacturer" required>
      <Text value={data.manufacturer} onChange={(v) => update('manufacturer', v)} required />
    </Field>
    <Field label="Type" required>
      <Text value={data.type} onChange={(v) => update('type', v)} required />
    </Field>
    <Field label="Set Pressure" required hint="Numbers only — use a decimal point if needed (e.g. 17.25).">
      <Text
        value={data.setPressure}
        onChange={(v) => update('setPressure', v)}
        inputMode="decimal"
        required
      />
    </Field>
    <Field label="Test Dates" required>
      <Text value={data.testDates} onChange={(v) => update('testDates', v)} required />
    </Field>
  </SectionShell>
);

export default ReliefValveSection;
